import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import sanitizeHtml from 'sanitize-html';

import { actionArticleShared } from 'actions';
import { LANGUAGES, SOCIAL_SHARE_SHAPE } from 'config/types/prop';
import { options } from 'config/reactRedux';
import withStyles from 'isomorphic-style-loader/withStyles';
import icons from 'config/icons';
import { sendEventToGA } from 'utils/googleAnalytics';
import breakpoints from 'config/css/breakpoints';
import getRuntimeConfiguration from 'utils/getRuntimeConfiguration';

import styles from './shareButtons.css';

const FACEBOOK_APP_ID = getRuntimeConfiguration('FACEBOOK_APP_ID');

const shareServices = {
  email: {
    base: 'mailto:?',
    title: 'subject',
    link: 'body',
  },
  facebook: {
    base: `https://www.facebook.com/dialog/share?app_id=${FACEBOOK_APP_ID}&display=popup`,
    link: 'href',
  },
  linkedin: {
    base: 'https://www.linkedin.com/shareArticle?mini=true',
    link: 'url',
    title: 'title',
    description: 'summary',
  },
  twitter: {
    base: 'https://twitter.com/intent/tweet?',
    link: 'url',
    title: 'text',
  },
  whatsapp: {
    base: 'https://api.whatsapp.com/send?',
    titleAndLink: 'text',
  },
  pinterest: {
    base: 'https://www.pinterest.com/pin/create/bookmarklet/?',
    link: 'url',
    image: 'media',
    title: 'description',
  },
};

class ShareButtons extends Component {
  onClickShare = (e, service) => {
    const { onShare } = this.props;
    if (window.matchMedia(breakpoints.lgMin).matches) {
      e.preventDefault();
      const windowWidth = 520;
      const windowHeight = 420;
      const left = (screen.width - windowWidth) / 2;
      const top = (screen.height - windowHeight) / 2;
      window.open(
        this.generateShareUrl(service),
        'DescriptiveWindowName',
        `width=${windowWidth},height=${windowHeight},top=${top},left=${left},resizable,scrollbars=yes,status=1`,
      );
    }

    onShare({ sharing_platform: service });
    sendEventToGA(service, 'Share');
  };

  getIconUrl = (service) => {
    // Some social platforms have updated svgs for share buttons only
    const altIcon = icons[`${service}Alt`];
    return altIcon || icons[service];
  };

  generateShareUrl = (service) => {
    const { currentEdition, shareProps } = this.props;
    const fragments = shareServices[service] || {};

    const urlParts = Object
      .keys(fragments)
      .map((shareProp) => {
        const name = fragments[shareProp];
        let value = encodeURIComponent(shareProps[shareProp]);

        if ('link' === shareProp || 'titleAndLink' === shareProp) {
          const GtmParameters = `?utm_source=${service}&utm_medium=social&utm_campaign=${currentEdition}mag`;
          value += encodeURIComponent(GtmParameters);
        }

        return 'base' === shareProp ? name :
          `${name}=${sanitizeHtml(value)}`;
      });

    const base = urlParts[0];
    return base.endsWith('?') ? base + urlParts.slice(1).join('&') : urlParts.join('&');
  };

  render() {
    const { services, isColumn } = this.props;

    return (
      <div className={styles.wrapper}>
        <ul className={classNames(
          styles.list,
          { [styles.column]: isColumn },
        )}
        >
          {services.map((service) => (
            <li className={styles.item} key={service}>
              <a
                rel="nofollow noopener noreferrer"
                href={this.generateShareUrl(service)}
                className={classNames(styles.link, styles[service])}
                onClick={(e) => this.onClickShare(e, service)}
                target="_blank"
              >
                <img
                  alt={`${service} icon`}
                  src={this.getIconUrl(service)}
                  height="35"
                  width="35"
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

ShareButtons.propTypes = {
  currentEdition: LANGUAGES,
  shareProps: SOCIAL_SHARE_SHAPE.isRequired,
  services: PropTypes.arrayOf(
    PropTypes.string,
  ),
  isColumn: PropTypes.bool,
  onShare: PropTypes.func.isRequired,
};

ShareButtons.defaultProps = {
  isColumn: false,
  currentEdition: 'en',
  shareProps: {
    link: '',
    title: 'Check this out',
    description: false,
    image: false,
  },
  services: [
    'facebook',
    'twitter',
    'linkedin',
    'whatsapp',
    'pinterest',
    'email',
  ],
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onShare: actionArticleShared,
}, dispatch);

const withRedux = connect(
  undefined,
  mapDispatchToProps,
  undefined,
  options,
);
const wrapWithStyles = withStyles(styles);

export default withRedux(wrapWithStyles(ShareButtons));
